export const PERMS = {
    READ: 'board.read',
    UPDATE: 'board.update',
    DELETE: 'board.delete',
    CREATE: 'board.create',
    EXPORT: 'board.export',
}
